<template>
	<div class="main" v-title data-title="零部件基本资料">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">实名认证</h1>
						</div>
						<div class="mt35 mr20">
							<div class="tipdiv">
								<p>1.沐风网实名认证系统，采用腾讯开发平台的“腾讯云慧眼人脸核身”程序（该程序已应用于中国工商银行，北京法院等金融，公安机构），
									无需用户上传身份证照片，数据完全上传至腾讯云，沐风网只接收是否核验成功的反回信息。不保存用户的任何身份数据信息。
									沐风网将以十二分的诚意保障您的个人信息的安全.</p>
								<p class="bold">2.请在手机上按提示操作，如果认证失败，请仔细阅读失败原因。如有问题请联系页面右侧企业微信</p>
							</div>
							
							<div class="txc codediv" v-if="htFlag=='default'">
								<span class="demonstration" style="color: red;">使用手机微信或任意手机浏览器扫一扫</span>
								<div class="demo-image">
									<div class="block">
										<div class="code" id="qrcode" ref="qrcode" style="display: inline-block;"></div>
									</div>
								</div>
								<span class="demonstration">提交后请刷新本页面</span>
							</div>
							<!-- v-else -->
							<div class="txc" v-else-if="htFlag=='success'" style="line-height: 25px;">
								<span class="el-icon-success" ></span>
								<span class="demonstration bold">
									{{sucessmsg}}
								</span>
								<p class="bold" v-if="flagsucess==true">您可以点击“后台管理”上传产品哦。</p>
							</div>
							<div class="txc" v-else-if="htFlag=='error'">
								<span class="el-icon-warning"></span>
								<span class="demonstration bold">
									您的认证信息被驳回
								</span>
								<div class="demonstration bohui">
									驳回理由：<span>{{con}}</span>
								</div>
								<el-button type="primary" size="medium" @click='editAPP' class="mt20 ">点击重新修改</el-button>
							</div>
							<div class="txc" v-else-if="htFlag=='wait'">
								<span class="el-icon-success"></span>
								<span class="demonstration bold">
									信息已提交,请等待审核！
								</span>
							</div>
							
							
						</div>
					
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import Cookies from 'js-cookie'
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import QRCode from 'qrcodejs2'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				titleDec: "",
				htFlag: "",
				con: '',
				sucessmsg:'',
				flagsucess:true
			}
		},
		created() {

			this.handPrrove();
		},
		methods: {
			handPrrove() {
				this.$postcn('partshome/isauth', '', this).then((res) => {
					if (res.data.status == 1) {
						this.htFlag = "success";
						this.sucessmsg=res.data.msg
						this.flagsucess=true
					} else if(res.data.status == 5){
						this.htFlag = "success";
						this.sucessmsg=res.data.msg
						this.flagsucess=false
					}else if (res.data.status == -1) {
						this.htFlag = "error";
						this.con = res.data.con;
					} else if (res.data.status == 2) {
						this.htFlag = "wait"
					} else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}
					else {
						this.htFlag = "default";
						this.handgettoken();
					}
					
				})
				
			},
			handgettoken() {
				 this.$nextTick(() => {
					 this.qrcode = new QRCode('qrcode', {
						//text:'https://www.baidu.com',
					 	text: 'https://m.mfcad.com.cn/m/#/pages/approve/iapprove?usertoken=' + Cookies.get('mf_service_ticket'),
					 	width: 250,
					 	height: 250,
					 });
				 })
			},
			editAPP() {
				this.htFlag = 'default'
				this.handgettoken();
			}
		}
	}
</script>

<style style="scoped">
	.codediv{
		line-height: 40px;
		padding-bottom: 40px;
	}
	.el-icon-warning ,.el-icon-success{
		/* display:block;font-size:86px; */
	}
	.el-icon-warning{
		color: #ccc;
	}
	.el-icon-success{
		color: #008400;
	}
	.bohui {
		width: 300px;
		text-align: center;
		margin: 0px auto;
		overflow: hidden;
		line-height: 22px;
		font-size: 14px;
	}

	.item1 {
		display: inline-block;
	}

/* 	.formW {
		width: 600PX;
		margin-top: 40PX;
	} */

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.tipdiv {
		font-size: 12px;
		line-height: 25px;
		background-color: #fff1f0;
		border: 1px solid #ffd7db;
		padding: 15px;
		margin-bottom: 20px;
		border-radius: 3px;
		margin:0px auto;
		margin-top: 25px;
		margin-bottom: 60px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/approve.vue